// extracted by mini-css-extract-plugin
export default {"small":"10px","medium":"20px","large":"28px","fontXsmall":"12px","darkGray":"#706b6b","pointColor":"#ffb8b8"};